import * as z from 'zod';

// Types
import { blocksSchemaZod } from '@/components/blocks/Blocks';
import { SeoZod } from '@/types/SeoType';

export const TechnoZod = z.object({
  id: z.number(),
  documentId: z.string(),
  slug: z.string(),
  blocks: z.array(blocksSchemaZod),
  seo: SeoZod,
});

export type TechnoType = z.infer<typeof TechnoZod>;

export const TechnoSlugZod = TechnoZod.pick({
  id: true,
  documentId: true,
  slug: true,
  seo: true,
});

export type TechnoSlugType = z.infer<typeof TechnoSlugZod>;
